<div class="new-login-ui">
    <div class="account-slider" [ngClass]="{'active-sign-up': !isLogin}"
        *ngIf="!isCurrentlyLogin">
        <div class="account-slider-wrapper">
            <div class="item">
                <div class="modal-body">
                    <div
                        class="row pt-0 align-items-center justify-content-between">
                        <div class="col-md-auto col-auto">
                            <div
                                class="pl-2 pl-md-5 site-title title-login-fonts text-left">LOGIN</div>
                        </div>
                        <div class="col-md-auto col-auto">
                            <span
                                class="material-icons pr-2 pr-md-5 d-flex cursor-pointer"
                                (click)="closeVideoPreview()">
                                cancel
                            </span>
                        </div>
                    </div>
                    <form [formGroup]="loginForm" class="login-form"
                        (ngSubmit)="onSubmit()">
                        <div
                            class="row justify-content-between align-items-center">
                            <div class="col-md-6 d-none d-md-flex">
                                <img src="/assets/images/login-bg.png"
                                    alt="247Invites">
                            </div>
                            <div class="col-md-5">
                                <div class="welcome-text">
                                    Welcome Back
                                </div>
                                <div class="form-group">
                                    <div class="login-control">
                                        <div class="login-info">
                                            <svg width="20" height="16"
                                                viewBox="0 0 20 16" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M18 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V2C20 0.9 19.1 0 18 0ZM17.6 4.25L10.53 8.67C10.21 8.87 9.79 8.87 9.47 8.67L2.4 4.25C2.29973 4.19371 2.21192 4.11766 2.14189 4.02645C2.07186 3.93525 2.02106 3.83078 1.99258 3.71937C1.96409 3.60796 1.9585 3.49194 1.97616 3.37831C1.99381 3.26468 2.03434 3.15581 2.09528 3.0583C2.15623 2.96079 2.23632 2.87666 2.33073 2.811C2.42513 2.74533 2.53187 2.69951 2.6445 2.6763C2.75712 2.65309 2.87328 2.65297 2.98595 2.67595C3.09863 2.69893 3.20546 2.74453 3.3 2.81L10 7L16.7 2.81C16.7945 2.74453 16.9014 2.69893 17.014 2.67595C17.1267 2.65297 17.2429 2.65309 17.3555 2.6763C17.4681 2.69951 17.5749 2.74533 17.6693 2.811C17.7637 2.87666 17.8438 2.96079 17.9047 3.0583C17.9657 3.15581 18.0062 3.26468 18.0238 3.37831C18.0415 3.49194 18.0359 3.60796 18.0074 3.71937C17.9789 3.83078 17.9281 3.93525 17.8581 4.02645C17.7881 4.11766 17.7003 4.19371 17.6 4.25Z"
                                                    fill="url(#paint0_linear_750_8644)" />
                                                <defs>
                                                    <lineargradient
                                                        id="paint0_linear_750_8644"
                                                        x1="-2.97971e-09"
                                                        y1="9.21739"
                                                        x2="20.0003"
                                                        y2="9.35349"
                                                        gradientUnits="userSpaceOnUse">
                                                        <stop
                                                            stop-color="#E63229" />
                                                        <stop offset="1"
                                                            stop-color="#EE4884" />
                                                    </lineargradient>
                                                </defs>
                                            </svg>
                                            <span>
                                                Email
                                            </span>
                                        </div>
                                        <input class="form-control" type="email"
                                            placeholder="Type email"
                                            formControlName="username"
                                            [ngClass]="{'red-border-class': submitted && f.username.errors}">
                                    </div>
                                    <p class="text-danger mt-2 mb-0 fs-14"
                                        *ngIf="submitted && f.username.errors &&f.username.errors.required">
                                        Please enter valid email
                                    </p>
                                </div>
                                <div class="form-group">
                                    <div class="login-control">
                                        <div class="login-info">
                                            <svg width="20" height="20"
                                                viewBox="0 0 20 20" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M15 5H20V15H15V17C15 17.2652 15.1054 17.5196 15.2929 17.7071C15.4804 17.8946 15.7348 18 16 18H18V20H15.5C14.95 20 14 19.55 14 19C14 19.55 13.05 20 12.5 20H10V18H12C12.2652 18 12.5196 17.8946 12.7071 17.7071C12.8946 17.5196 13 17.2652 13 17V3C13 2.73478 12.8946 2.48043 12.7071 2.29289C12.5196 2.10536 12.2652 2 12 2H10V0H12.5C13.05 0 14 0.45 14 1C14 0.45 14.95 0 15.5 0H18V2H16C15.7348 2 15.4804 2.10536 15.2929 2.29289C15.1054 2.48043 15 2.73478 15 3V5ZM0 5H11V7H2V13H11V15H0V5ZM18 13V7H15V13H18ZM6.5 10C6.5 9.60218 6.34196 9.22064 6.06066 8.93934C5.77936 8.65804 5.39782 8.5 5 8.5C4.60218 8.5 4.22064 8.65804 3.93934 8.93934C3.65804 9.22064 3.5 9.60218 3.5 10C3.5 10.3978 3.65804 10.7794 3.93934 11.0607C4.22064 11.342 4.60218 11.5 5 11.5C5.39782 11.5 5.77936 11.342 6.06066 11.0607C6.34196 10.7794 6.5 10.3978 6.5 10ZM11 8.89C10.39 8.33 9.44 8.38 8.88 9C8.32 9.6 8.37 10.55 9 11.11C9.55 11.63 10.43 11.63 11 11.11V8.89Z"
                                                    fill="url(#paint0_linear_750_8650)" />
                                                <defs>
                                                    <lineargradient
                                                        id="paint0_linear_750_8650"
                                                        x1="-2.97971e-09"
                                                        y1="11.5217"
                                                        x2="20.0006"
                                                        y2="11.6306"
                                                        gradientUnits="userSpaceOnUse">
                                                        <stop
                                                            stop-color="#E63229" />
                                                        <stop offset="1"
                                                            stop-color="#EE4884" />
                                                    </lineargradient>
                                                </defs>
                                            </svg>
                                            <span>
                                                Password
                                            </span>
                                        </div>
                                        <input class="form-control"
                                            type="password"
                                            placeholder="Type password"
                                            formControlName="password"
                                            [ngClass]="{'red-border-class' : submitted && f.password.errors}">
                                    </div>
                                    <p class="text-danger mt-1 mb-0 fs-14"
                                        *ngIf="submitted && f.username.errors && f.password.errors.required">Please
                                        enter
                                        correct password</p>
                                </div>
                                <div>
                                    <p class="forgot-password-link mb-3">
                                        <a routerLink="/user/forgetpassword">
                                            Forgot password?
                                        </a>
                                    </p>
                                    <div class="text-center">
                                        <button type="submit"
                                            class="btn btn-primary-main mx-auto mb-3"
                                            *ngIf="!isWaitingForLogin">Login
                                        </button>
                                        <button
                                            class="btn btn-login mx-auto mb-3"
                                            *ngIf="isWaitingForLogin">Please
                                            Wait...
                                        </button>
                                        <p
                                            class="forgot-password-link mt-3 line-heading">Don't
                                            have a 247Invites account?
                                        </p>
                                        <button style="border-radius: 10px;"
                                            type='button'
                                            (click)="switchLoginForm(1)"
                                            class="btn btn-primary-outline mx-auto mb-3">Sign
                                            Up
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="item">
                <div class="modal-body">
                    <div class="row pt-0 align-items-center">
                        <div class="col-md-auto col-auto">
                            <span
                                class="ml-0 ml-md-4 material-icons d-flex cursor-pointer"
                                (click)="switchLoginForm(2)">
                                west
                            </span>
                        </div>
                        <div class="col-md col-auto">
                            <div
                                class="site-title title-login-fonts text-left">SIGNUP</div>
                        </div>
                        <div class="col-md-auto col-auto ml-auto">
                            <span
                                class="material-icons pr-2 pr-md-5 d-flex cursor-pointer"
                                (click)="closeVideoPreview()">
                                cancel
                            </span>
                        </div>
                    </div>
                    <form [formGroup]="signUpForm" class="login-form"
                        (ngSubmit)="onRegisterSubmit()">
                        <div
                            class="row justify-content-between align-items-center">
                            <div class="col-md-6 d-none d-md-flex">
                                <img src="/assets/images/login-bg.png"
                                    alt="247Invites">
                            </div>
                            <div class="col-md-5 pl-0">
                                <div class="welcome-text">
                                    A few details
                                </div>
                                <div class="form-group">
                                    <div class="login-control">
                                        <div class="login-info">
                                            <svg width="14" height="16"
                                                viewBox="0 0 14 16" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M7 8.8C8.86356 8.8 10.5583 9.3552 11.8051 10.1376C12.4273 10.528 12.9593 10.9888 13.3436 11.4896C13.7216 11.9816 14 12.5704 14 13.2C14 13.876 13.6803 14.4088 13.2199 14.7888C12.7843 15.1488 12.2096 15.3872 11.599 15.5536C10.3717 15.8872 8.73367 16 7 16C5.26633 16 3.62833 15.888 2.401 15.5536C1.79044 15.3872 1.21567 15.1488 0.780111 14.7888C0.318889 14.408 0 13.876 0 13.2C0 12.5704 0.278445 11.9816 0.656445 11.4888C1.04067 10.9888 1.57189 10.5288 2.19489 10.1368C3.44167 9.356 5.13722 8.8 7 8.8ZM7 0C8.0314 0 9.02055 0.421427 9.74986 1.17157C10.4792 1.92172 10.8889 2.93913 10.8889 4C10.8889 5.06087 10.4792 6.07828 9.74986 6.82843C9.02055 7.57857 8.0314 8 7 8C5.9686 8 4.97945 7.57857 4.25014 6.82843C3.52083 6.07828 3.11111 5.06087 3.11111 4C3.11111 2.93913 3.52083 1.92172 4.25014 1.17157C4.97945 0.421427 5.9686 0 7 0Z"
                                                    fill="url(#paint0_linear_750_8854)" />
                                                <defs>
                                                    <lineargradient
                                                        id="paint0_linear_750_8854"
                                                        x1="-2.08579e-09"
                                                        y1="9.21739"
                                                        x2="14.0005"
                                                        y2="9.28408"
                                                        gradientUnits="userSpaceOnUse">
                                                        <stop
                                                            stop-color="#E63229" />
                                                        <stop offset="1"
                                                            stop-color="#EE4884" />
                                                    </lineargradient>
                                                </defs>
                                            </svg>
                                            <span>
                                                Name
                                            </span>
                                        </div>
                                        <input class="form-control" type="text"
                                            placeholder="Type name"
                                            formControlName="name">
                                    </div>
                                    <p class="text-danger mt-2 mb-0 fs-14"
                                        *ngIf="signUpSubmitted && r.name.errors">Name
                                        is
                                        required
                                    </p>
                                </div>
                                <div class="form-group">
                                    <div class="login-control">
                                        <div class="login-info">
                                            <svg width="17" height="16"
                                                viewBox="0 0 17 16" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M11.8592 10.2645L11.4295 10.6909C11.4295 10.6909 10.4066 11.7036 7.61581 8.93841C4.825 6.17321 5.84782 5.16049 5.84782 5.16049L6.11793 4.89131C6.78565 4.2306 6.84893 3.16895 6.26621 2.39341L5.07622 0.809399C4.35467 -0.150609 2.96162 -0.277668 2.13524 0.541162L0.652471 2.00941C0.243529 2.416 -0.030358 2.94118 0.00269731 3.52471C0.0876968 5.01837 0.765803 8.23064 4.54733 11.9784C8.55836 15.9521 12.3219 16.1102 13.8604 15.9672C14.3478 15.922 14.7709 15.6754 15.1118 15.3366L16.4529 14.0076C17.3596 13.1107 17.1046 11.5718 15.9448 10.9441L14.1409 9.96618C13.3797 9.55488 12.4542 9.67535 11.8592 10.2645Z"
                                                    fill="url(#paint0_linear_750_8860)" />
                                                <defs>
                                                    <lineargradient
                                                        id="paint0_linear_750_8860"
                                                        x1="-2.53275e-09"
                                                        y1="9.21739"
                                                        x2="17.0004"
                                                        y2="9.31572"
                                                        gradientUnits="userSpaceOnUse">
                                                        <stop
                                                            stop-color="#E63229" />
                                                        <stop offset="1"
                                                            stop-color="#EE4884" />
                                                    </lineargradient>
                                                </defs>
                                            </svg>
                                            <span>
                                                Phone
                                            </span>
                                        </div>
                                        <ngx-intl-tel-input
                                            [cssClass]="'form-control'"
                                            [preferredCountries]="preferredCountries"
                                            [enableAutoCountrySelect]="true"
                                            [searchCountryFlag]="true"
                                            [searchCountryField]="[
                                          SearchCountryField.Iso2,
                                          SearchCountryField.Name
                                        ]"
                                            [selectFirstCountry]="false"
                                            [selectedCountryISO]="CountryISO.India"
                                            [maxLength]="15"
                                            [phoneValidation]="true"
                                            [separateDialCode]="separateDialCode"
                                            [numberFormat]="PhoneNumberFormat.National"
                                            name="phone"
                                            formControlName="phone">
                                        </ngx-intl-tel-input>
                                        <!-- <input class="" type="text"
                                            placeholder="Type phone"
                                            formControlName="phone"> -->
                                    </div>
                                    <p class="text-danger mt-2 mb-0 fs-14"
                                        *ngIf="signUpSubmitted && r.phone.errors">
                                        Phone
                                        number is
                                        not valid
                                    </p>
                                </div>
                                <div class="form-group">
                                    <div class="login-control">
                                        <div class="login-info">
                                            <svg width="20" height="16"
                                                viewBox="0 0 20 16" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M18 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V2C20 0.9 19.1 0 18 0ZM17.6 4.25L10.53 8.67C10.21 8.87 9.79 8.87 9.47 8.67L2.4 4.25C2.29973 4.19371 2.21192 4.11766 2.14189 4.02645C2.07186 3.93525 2.02106 3.83078 1.99258 3.71937C1.96409 3.60796 1.9585 3.49194 1.97616 3.37831C1.99381 3.26468 2.03434 3.15581 2.09528 3.0583C2.15623 2.96079 2.23632 2.87666 2.33073 2.811C2.42513 2.74533 2.53187 2.69951 2.6445 2.6763C2.75712 2.65309 2.87328 2.65297 2.98595 2.67595C3.09863 2.69893 3.20546 2.74453 3.3 2.81L10 7L16.7 2.81C16.7945 2.74453 16.9014 2.69893 17.014 2.67595C17.1267 2.65297 17.2429 2.65309 17.3555 2.6763C17.4681 2.69951 17.5749 2.74533 17.6693 2.811C17.7637 2.87666 17.8438 2.96079 17.9047 3.0583C17.9657 3.15581 18.0062 3.26468 18.0238 3.37831C18.0415 3.49194 18.0359 3.60796 18.0074 3.71937C17.9789 3.83078 17.9281 3.93525 17.8581 4.02645C17.7881 4.11766 17.7003 4.19371 17.6 4.25Z"
                                                    fill="url(#paint0_linear_750_8644)" />
                                                <defs>
                                                    <lineargradient
                                                        id="paint0_linear_750_8644"
                                                        x1="-2.97971e-09"
                                                        y1="9.21739"
                                                        x2="20.0003"
                                                        y2="9.35349"
                                                        gradientUnits="userSpaceOnUse">
                                                        <stop
                                                            stop-color="#E63229" />
                                                        <stop offset="1"
                                                            stop-color="#EE4884" />
                                                    </lineargradient>
                                                </defs>
                                            </svg>
                                            <span>
                                                Email
                                            </span>
                                        </div>
                                        <input class="form-control" type="email"
                                            placeholder="Type email"
                                            formControlName="username">
                                    </div>
                                    <p class="text-danger mt-2 fs-14 mb-0"
                                        *ngIf="signUpSubmitted && r.username.errors">
                                        Please
                                        enter valid
                                        email</p>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 pr-2">
                                        <div class="form-group">
                                            <div class="login-control">
                                                <div class="login-info">
                                                    <svg width="20" height="20"
                                                        viewBox="0 0 20 20"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M15 5H20V15H15V17C15 17.2652 15.1054 17.5196 15.2929 17.7071C15.4804 17.8946 15.7348 18 16 18H18V20H15.5C14.95 20 14 19.55 14 19C14 19.55 13.05 20 12.5 20H10V18H12C12.2652 18 12.5196 17.8946 12.7071 17.7071C12.8946 17.5196 13 17.2652 13 17V3C13 2.73478 12.8946 2.48043 12.7071 2.29289C12.5196 2.10536 12.2652 2 12 2H10V0H12.5C13.05 0 14 0.45 14 1C14 0.45 14.95 0 15.5 0H18V2H16C15.7348 2 15.4804 2.10536 15.2929 2.29289C15.1054 2.48043 15 2.73478 15 3V5ZM0 5H11V7H2V13H11V15H0V5ZM18 13V7H15V13H18ZM6.5 10C6.5 9.60218 6.34196 9.22064 6.06066 8.93934C5.77936 8.65804 5.39782 8.5 5 8.5C4.60218 8.5 4.22064 8.65804 3.93934 8.93934C3.65804 9.22064 3.5 9.60218 3.5 10C3.5 10.3978 3.65804 10.7794 3.93934 11.0607C4.22064 11.342 4.60218 11.5 5 11.5C5.39782 11.5 5.77936 11.342 6.06066 11.0607C6.34196 10.7794 6.5 10.3978 6.5 10ZM11 8.89C10.39 8.33 9.44 8.38 8.88 9C8.32 9.6 8.37 10.55 9 11.11C9.55 11.63 10.43 11.63 11 11.11V8.89Z"
                                                            fill="url(#paint0_linear_750_8650)" />
                                                        <defs>
                                                            <lineargradient
                                                                id="paint0_linear_750_8650"
                                                                x1="-2.97971e-09"
                                                                y1="11.5217"
                                                                x2="20.0006"
                                                                y2="11.6306"
                                                                gradientUnits="userSpaceOnUse">
                                                                <stop
                                                                    stop-color="#E63229" />
                                                                <stop offset="1"
                                                                    stop-color="#EE4884" />
                                                            </lineargradient>
                                                        </defs>
                                                    </svg>
                                                    <span>
                                                        Password
                                                    </span>
                                                </div>
                                                <input
                                                    class="form-control form-control-lg"
                                                    type="password"
                                                    placeholder="Type password"
                                                    formControlName="confirmPassword">
                                            </div>
                                            <p
                                                class="text-danger fs-14 mt-1 mb-0"
                                                *ngIf="signUpSubmitted && r.confirmPassword.errors">Confirm
                                                Password is required</p>
                                            <p
                                                class="text-danger fs-14 mt-1 mb-0"
                                                *ngIf="signUpSubmitted && !r.confirmPassword.errors && (r.password.value != r.confirmPassword.value)">
                                                Confirm Password should Match
                                                with Password</p>
                                        </div>
                                    </div>
                                    <div class="col-md-6 pl-2">
                                        <div class="form-group">
                                            <div class="login-control">
                                                <div class="login-info">
                                                    <svg width="20" height="20"
                                                        viewBox="0 0 20 20"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M15 5H20V15H15V17C15 17.2652 15.1054 17.5196 15.2929 17.7071C15.4804 17.8946 15.7348 18 16 18H18V20H15.5C14.95 20 14 19.55 14 19C14 19.55 13.05 20 12.5 20H10V18H12C12.2652 18 12.5196 17.8946 12.7071 17.7071C12.8946 17.5196 13 17.2652 13 17V3C13 2.73478 12.8946 2.48043 12.7071 2.29289C12.5196 2.10536 12.2652 2 12 2H10V0H12.5C13.05 0 14 0.45 14 1C14 0.45 14.95 0 15.5 0H18V2H16C15.7348 2 15.4804 2.10536 15.2929 2.29289C15.1054 2.48043 15 2.73478 15 3V5ZM0 5H11V7H2V13H11V15H0V5ZM18 13V7H15V13H18ZM6.5 10C6.5 9.60218 6.34196 9.22064 6.06066 8.93934C5.77936 8.65804 5.39782 8.5 5 8.5C4.60218 8.5 4.22064 8.65804 3.93934 8.93934C3.65804 9.22064 3.5 9.60218 3.5 10C3.5 10.3978 3.65804 10.7794 3.93934 11.0607C4.22064 11.342 4.60218 11.5 5 11.5C5.39782 11.5 5.77936 11.342 6.06066 11.0607C6.34196 10.7794 6.5 10.3978 6.5 10ZM11 8.89C10.39 8.33 9.44 8.38 8.88 9C8.32 9.6 8.37 10.55 9 11.11C9.55 11.63 10.43 11.63 11 11.11V8.89Z"
                                                            fill="url(#paint0_linear_750_8650)" />
                                                        <defs>
                                                            <lineargradient
                                                                id="paint0_linear_750_8650"
                                                                x1="-2.97971e-09"
                                                                y1="11.5217"
                                                                x2="20.0006"
                                                                y2="11.6306"
                                                                gradientUnits="userSpaceOnUse">
                                                                <stop
                                                                    stop-color="#E63229" />
                                                                <stop offset="1"
                                                                    stop-color="#EE4884" />
                                                            </lineargradient>
                                                        </defs>
                                                    </svg>
                                                    <span>
                                                        Password
                                                    </span>
                                                </div>
                                                <input class="form-control"
                                                    type="password"
                                                    placeholder="Confirm Password"
                                                    formControlName="password">
                                            </div>
                                            <p
                                                class="text-danger mt-1 mb-0 fs-14"
                                                *ngIf="signUpSubmitted && r.password.errors">
                                                Cofirm password is
                                                required</p>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <p class="forgot-password-link mb-3">
                                        <a routerLink="/user/forgetpassword">
                                            Forgot password?
                                        </a>
                                    </p>
                                    <div class="text-center">
                                        <button [disabled]="spinnerVisible"
                                            class="btn btn-primary-main mx-auto mb-3 mt-0">
                                            <span *ngIf="spinnerVisible"
                                                class="spinner-border spinner-border-sm mr-1"></span>
                                            Sign Up
                                        </button>

                                        <p class="forgot-password-link">Already
                                            have an account?
                                            <a href="javascript:void(0)"
                                                (click)="switchLoginForm(2)">
                                                Log In
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
